<template>
  <div class="home_wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "VehiclesHome",
};
</script>
